import React from 'react'
import AboutMeSection from '../components/home/AboutMeSection'
import AppLayout from '../App'

function AboutMe() {
  return (
    <AppLayout>
        <AboutMeSection/>
    </AppLayout>
  )
}

export default AboutMe